import React, { Component } from "react";
import "./MAMCASurvey.css";
import VUBlogo from '../img/VUB- VERTICAAL.jpg'; // Tell Webpack this JS file uses this image
import {
    message, Row, Col, Button, Icon, Form,
    Radio, Input, ConfigProvider, Table, Empty,
    Popover, Popconfirm, notification, Divider
} from 'antd';

//create criteria weight modal
let CriteriaForm = Form.create({ name: 'Cform_in_modal' })(
    // eslint-disable-next-line
    class extends Component {
        render() {
            const {
                projectActorGroup, form
            } = this.props; //read all the property send from Alternative

            const { getFieldDecorator } = form; //can get the input value
            // const radioStyle = {
            //     display: 'block',
            // };
            let criteria = [];
            let subCriteria = [];
            let sub = false
            for (let i in projectActorGroup.actorCriteria) {
                if (projectActorGroup.actorCriteria[i].subCriteria && projectActorGroup.actorCriteria[i].subCriteria.length > 1) { //more than one sub-criteria
                    sub = true
                    subCriteria.push(
                        <b key={`${projectActorGroup.actorCriteria[i].criteriaName}group`}>Criteria group: {projectActorGroup.actorCriteria[i].criteriaName}</b>
                    )
                    projectActorGroup.actorCriteria[i].subCriteria.forEach(sobj => {
                        subCriteria.push(
                            <Form.Item style={{ marginTop: "2vh" }} label={sobj.subCriteriaName} key={`${projectActorGroup.actorCriteria[i].criteriaName}W%m$e${sobj.subCriteriaName}`}>
                                {getFieldDecorator(`${projectActorGroup.actorCriteria[i].criteriaName}W%m$e${sobj.subCriteriaName}`, {
                                    rules: [{
                                        required: true,
                                        message: `Value is required.`,
                                    }]
                                })(
                                    <Radio.Group size="large">
                                        <Radio value={0}>N/A</Radio>
                                        <Radio value={1}>1</Radio>
                                        <Radio value={2}>2</Radio>
                                        <Radio value={3}>3</Radio>
                                        <Radio value={4}>4</Radio>
                                        <Radio value={5}>5</Radio>
                                    </Radio.Group>
                                )}
                            </Form.Item>
                        )
                    })
                }
                criteria.push(
                    <Form.Item style={{ marginTop: "2vh" }} label={projectActorGroup.actorCriteria[i].criteriaName} key={`${projectActorGroup.actorCriteria[i].criteriaName}`}>
                        {getFieldDecorator(`${projectActorGroup.actorCriteria[i].criteriaName}`, {
                            rules: [{
                                required: true,
                                message: `Value is required.`,
                            }]
                        })(
                            <Radio.Group size="large">
                                <Radio value={0}>N/A</Radio>
                                <Radio value={1}>1</Radio>
                                <Radio value={2}>2</Radio>
                                <Radio value={3}>3</Radio>
                                <Radio value={4}>4</Radio>
                                <Radio value={5}>5</Radio>
                            </Radio.Group>
                        )}
                    </Form.Item>
                );
            }
            return (
                <Form layout="vertical">
                    <h2>For each criterion (criteria group) please select one score for the relative importance of this criterion with respect to the most important one(s)</h2>
                    <h3>Note: at least one criterion must be 'Most Important'</h3>
                    <b>N/A Not relative | 1 Least important | 2 Less important | 3 Middle | 4 More Important | 5 Most important</b>
                    {criteria}
                    {sub ?
                        <h3>Within each criteria group, please select one score for the relative importance of this sub-criterion with respect to the most important one(s)</h3>
                        : <span></span>}
                    {sub ? subCriteria : <span></span>}
                    <Form.Item label="Contact">
                        {getFieldDecorator('Contact', {
                            rules: [
                                {
                                    required: true,
                                    message: 'Please leave your contact information',
                                },
                            ],
                        })(<Input placeholder="Please provide your contact details: Name, Email Address, or Phone Number." />)}
                    </Form.Item>
                </Form>
            );
        }
    }
);

// //create evaluation modal
// let EvaluationForm = Form.create({ name: 'Eform_in_modal' })(
//     // eslint-disable-next-line
//     class extends Component {
//         render() {
//             const {
//                 projectActorGroup, form, project
//             } = this.props; //read all the property send from Alternative

//             const { getFieldDecorator } = form; //can get the input value
//             // const radioStyle = {
//             //     display: 'block',
//             // };
//             let evaList = [];
//             for (let i in projectActorGroup.actorCriteria) {
//                 if (projectActorGroup.actorCriteria[i].subCriteria && projectActorGroup.actorCriteria[i].subCriteria.length > 0) { //there is sub-criteria
//                     projectActorGroup.actorCriteria[i].subCriteria.forEach(sobj => {
//                         evaList.push(
//                             <big style={{fontSize: "150%", color:"black"}}><b key={`${sobj.subCriteriaName}evaluation`}>Criterion: {sobj.subCriteriaName}</b></big>
//                         )
//                         project.projectAlternatives.forEach(aobj => { //each alternative has one evaluation
//                             evaList.push(
//                                 <Form.Item style={{ marginTop: "2vh" }} label={aobj.alternativeName} key={`${sobj.subCriteriaName}W%m$e${aobj.alternativeName}`}>
//                                     {getFieldDecorator(`${sobj.subCriteriaName}W%m$e${aobj.alternativeName}`, {
//                                         rules: [{
//                                             required: true,
//                                             message: `Value is required.`,
//                                         }]
//                                     })(
//                                         <Radio.Group size="large">
//                                             <Radio value={0}>0</Radio>
//                                             <Radio value={1}>1</Radio>
//                                             <Radio value={2}>2</Radio>
//                                             <Radio value={3}>3</Radio>
//                                             <Radio value={4}>4</Radio>
//                                             <Radio value={5}>5</Radio>
//                                         </Radio.Group>
//                                     )}
//                                 </Form.Item>)
//                         })
//                         evaList.push(<Divider style={{ marginTop: "2vh" }}/>)
//                     })
//                 }
//                 else { //there is no sub-criterion
//                     evaList.push(
//                         <big style={{fontSize: "150%",color:"black"}}><b key={`${projectActorGroup.actorCriteria[i].criteriaName}evaluation`}>Criterion: {projectActorGroup.actorCriteria[i].criteriaName}</b></big>
//                     )
//                     project.projectAlternatives.forEach(aobj => { //each alternative has one evaluation
//                         evaList.push(
//                             <Form.Item style={{ marginTop: "2vh" }} label={aobj.alternativeName} key={`${projectActorGroup.actorCriteria[i].criteriaName}W%m$e${aobj.alternativeName}`}>
//                                 {getFieldDecorator(`${projectActorGroup.actorCriteria[i].criteriaName}W%m$e${aobj.alternativeName}`, {
//                                     rules: [{
//                                         required: true,
//                                         message: `Value is required.`,
//                                     }]
//                                 })(
//                                     <Radio.Group size="large">
//                                         <Radio value={0}>0</Radio>
//                                         <Radio value={1}>1</Radio>
//                                         <Radio value={2}>2</Radio>
//                                         <Radio value={3}>3</Radio>
//                                         <Radio value={4}>4</Radio>
//                                         <Radio value={5}>5</Radio>
//                                     </Radio.Group>
//                                 )}
//                             </Form.Item>)
//                     })
//                 }
//                 evaList.push(<Divider style={{ marginTop: "2vh" }}/>)
//             }
//             return (
//                 <Form layout="vertical">
//                     <h3>Based on each criterion for each alternative please select one performance score</h3>
//                     {/* no need <h4>Note: at least one alternative for each criterion must be <b>5</b></h4> */}
//                     {evaList}
//                 </Form>
//             );
//         }
//     }
// );

export default class MAMCAWeightSurvey extends Component {
    constructor(props) {
        super(props);

        this.state = {
            project: {},
            loading: true, //the loading status default true
            projectName: "",
            projectActorGroup: {},
            projectDescription: "",
            role: "",
            count: 0,
            maximumCount: 1,
            steps: [0, 1, 2, 3],
        };
    }

    onclick(type) {
        this.setState(prevState => {
            return { count: type === 'add' ? this.state.steps[this.state.steps.indexOf(prevState.count) + 1] : this.state.steps[this.state.steps.indexOf(prevState.count) - 1] }
        });
    }

    submit = () => {
        var error = false
        var weightTable = {}
        var evaTable = {}

        this.CFormRef.props.form.validateFields((err, values) => { //can get values based on name
            if (err) { //trim the project name to check the length
                message.error('Please allocate the weights for all criteria!')
                error = true
                return;
            }
            let noFive = false
            let noSCFive = false
            let cGreat = 0
            let scGreat = 0
            let cGroup = "" //to record the criteria group name
            for (var v in values) { //check if there is no 5 filled
                let match = v.split('W%m$e') //split the words
                if (match.length === 1) { //criteria
                    if (values[v] > cGreat) {
                        cGreat = values[v]
                    }
                }
                else { //sub criteria
                    if (cGroup !== match[0]) { //in a new group
                        if (cGroup !== "" && scGreat !== 5) { //there is no 5 in the group
                            noSCFive = true
                        }
                        cGroup = match[0]
                        scGreat = 0
                    }
                    if (values[v] > scGreat) { //criteria
                        scGreat = values[v]
                    }
                }
            }
            if (cGroup !== "" && scGreat !== 5) { //the last group and there is subcriteria
                noSCFive = true
            }
            if (cGreat !== 5) {
                noFive = true
            }
            if (noFive) {
                message.error('Please give at least one criterion 5!')
                error = true
                return;
            }
            else if (noSCFive) {
                message.error('Please give at least one criterion 5 wihin the criteria group!')
                error = true
                return;
            }
            else { //start to caculate data
                let score = {}
                score.criteria = 0
                for (var x in values) { //check if there is no 5 filled
                    let match = x.split('W%m$e') //split the words
                    if (match.length === 1) { //criteria
                        score.criteria += values[x]
                    }
                    else { //sub criteria
                        if (match[0] in score) {
                            score[match[0]] += values[x] //push sub-criterion into group
                        }
                        else {
                            score[match[0]] = values[x]
                        }
                    }
                }
                for (var y in values) { //check if there is no 5 filled
                    let match = y.split('W%m$e') //split the words
                    if (match.length === 1) { //criteria
                        weightTable[y] = values[y] /// score.criteria
                    }
                    else { //sub criteria
                        weightTable[match[1]] = values[y] /// score[match[0]]
                    }
                }
            }
        })

        // if (this.state.projectActorGroup.actorSurveySettings.actorEvaluatable) { //there are SD questions
        //     this.EFormRef.props.form.validateFields((err, values) => { //can get values based on name
        //         if (err) { //trim the project name to check the length
        //             message.error('Please give scores to all options!')
        //             error = true
        //             return;
        //         }
        //         let cGroup = ""
        //         let scGreat = 0
        //         let noFive = false
        //         //no need for at least 5
        //         // for (var v in values) { //check if there is no 5 for alternatives
        //         //     let match = v.split('W%m$e') //split the words
        //         //     if (cGroup !== match[0]) { //in a new group
        //         //         if (cGroup !== "" && scGreat !== 5) { //there is no 5 in the group
        //         //             noFive = true
        //         //         }
        //         //         cGroup = match[0]
        //         //         scGreat = 0
        //         //     }
        //         //     if (values[v] > scGreat) { //criteria
        //         //         scGreat = values[v]
        //         //     }
        //         // }
        //         // if (noFive || scGreat !== 5) { // no need
        //         //     message.error('Please give at least one alterntive 5 for every criterion!')
        //         //     error = true
        //         //     return;
        //         // }
        //         // else {
        //         let pScore = {}
        //         pScore.criteria = 0
        //         for (var x in values) { //check if there is no 5 filled
        //             let match = x.split('W%m$e') //split the words
        //             if (match[0] in pScore) {
        //                 pScore[match[0]] += values[x] //push sub-criterion into group
        //             }
        //             else {
        //                 pScore[match[0]] = values[x]
        //             }
        //         }
        //         for (var y in values) { //check if there is no 5 filled
        //             let match = y.split('W%m$e') //split the words
        //             if (match[0] in evaTable) {
        //                 evaTable[match[0]][match[1]] = values[y] /// pScore[match[0]]
        //             }
        //             else {
        //                 evaTable[match[0]] = {}
        //                 evaTable[match[0]][match[1]] = values[y] /// pScore[match[0]]
        //             }
        //         }
        //         // }
        //     })
        // }
        if (!error) {
            fetch('/project/submitWeightSurvey', { //REST create project
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    uid: this.props.match.params.projectid,
                    actid: this.props.match.params.actorid, //get the id of actor
                    weightTable: weightTable,
                    // evaTable: evaTable
                }),
            }).then(res => res.json())
                .then(json => {
                    if (json.success) {
                        this.getSurveyInformation();
                        // message.success(json.message); //create successfully, show message
                        notification.open({
                            message: 'Survey Submitted',
                            description: 'Thanks for your participation!',
                            icon: <Icon type="smile" style={{ color: '#108ee9' }} />,
                        });
                        this.CFormRef.props.form.resetFields(); //reset the form
                        // this.EFormRef.props.form.resetFields(); //reset the form
                        this.props.history.push("/");
                    }
                    else {
                        message.error(json.message); //create unsuccessful, show alert
                    }
                });
        }
    }

    //get the survey information
    getSurveyInformation = () => {
        fetch(`/project/getSurveyInformation/${this.props.match.params.projectid}/${this.props.match.params.actorid}`, { //get the project id from link
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
        }).then(res => res.json())
            .then(json => {
                if (json.success) {
                    let maximumCount = 1
                    let steps = []
                    maximumCount = 3
                    steps = [0, 2, 3]
                    this.setState({
                        project: json.project,
                        projectName: json.projectName,
                        projectActorGroup: json.projectActorGroup,
                        projectDescription: json.project.projectDescription,
                        maximumCount: maximumCount,
                        steps: steps,
                        role: json.role,
                        loading: false
                    }) //save project data
                }
                else {
                    message.error(json.message)
                    this.props.history.push("/"); //redirect to homepage if the project not exist, shouldn't be a case
                }
            });
    }

    //save all the form data of Criteria weight
    saveCFormRef = (formRef) => {
        this.CFormRef = formRef;
    }

    componentDidMount() {
        try {
            this.getSurveyInformation() //after render immediately get alternative list
            window.onbeforeunload = function (e) {
                var dialogText = 'Are you certain? Any unsaved data you have entered will be lost.';
                e.returnValue = dialogText;
                return dialogText;
            };
        } catch (e) {
            alert(e);
        }
    }
    render() {
        let content0 = ( //evaluator list default
            <Col span={16} style={this.state.count === 0 ? { visibility: "visible" } : { visibility: "hidden", display: "none" }}>
                <Row style={{ marginTop: "2vh" }} type="flex" justify="space-around" align="middle">
                    <Col >
                        <div className="lander">
                            <div style={{ height: "100%" }} >
                                <h1 style={{ display: "inline" }}>Welcome to MAMCA<sup>&copy; </sup> survey </h1><img src={VUBlogo} style={{ height: "15vh" }} alt="Logo" />
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row style={{ marginTop: "5vh" }} type="flex" justify="space-around" align="middle">
                    <Col span={16} >
                        <h3 style={{ marginTop: "5vh" }}>You are invited to give your opinions in the project: {this.state.projectName}</h3>
                    </Col>
                </Row>
                <Row type="flex" justify="space-around" align="middle">
                    <Col span={16} >
                        <h3 style={{ marginTop: "5vh" }}>Your role: {this.state.role}</h3>
                    </Col>
                </Row>
                <Row type="flex" justify="space-around" align="middle">
                    <Col span={16} >
                        <b style={{ marginTop: "5vh" }}>Project description: {this.state.projectDescription}</b>
                    </Col>
                </Row>
            </Col>
        );
        let content2
        if (this.state.projectActorGroup.actorCriteria) {
            let alternativeList = JSON.parse(JSON.stringify(this.state.project.projectAlternatives))

            let criteriaList = JSON.parse(JSON.stringify(this.state.projectActorGroup.actorCriteria))
            criteriaList.forEach(function (obj) { //change the structure of criteria make it can be listed as children
                obj["children"] = obj.subCriteria
                delete obj["subCriteria"];
                obj.children.forEach(function (subobj) {
                    subobj["criteriaName"] = subobj.subCriteriaName
                    delete subobj["subCriteriaName"];
                    subobj["criteriaIndicator"] = subobj.subCriteriaIndicator
                    delete subobj["subCriteriaIndicator"];
                    subobj["criteriaDescription"] = subobj.subCriteriaDescription
                    delete subobj["subCriteriaDescription"];
                    subobj["criteriaWeight"] = subobj.subCriteriaWeight
                    delete subobj["subCriteriaWeight"];
                    subobj["cid"] = obj._id
                    subobj["pCiteriaName"] = obj.criteriaName
                })
                if (obj.children.length === 0) {
                    delete obj["children"];
                }
            })
            const columns = [{ //the column title of the table
                title: 'Criteria Name', //the title of column
                dataIndex: 'criteriaName', //the data index can be used for searching, filtering
                key: 'criteriaName',
                sorter: (a, b) => { if (a.criteriaName > b.criteriaName) { return -1; } if (a.criteriaName < b.criteriaName) { return 1; } return 0; },
                render: (text, record) => <Popover content={record.criteriaDescription} title="Description"><span style={{ cursor: "pointer" }}>{text}</span></Popover>, //make it clickable to the project
                width: '50%',
            },
            { //the column title of the table
                title: 'Criteria Indicator', //the title of column
                dataIndex: 'criteriaIndicator', //the data index can be used for searching, filtering
                key: 'criteriaIndicator',
                width: '50%',
            },
            ];

            const Acolumns = [{ //the column title of the table
                title: 'Alternative Name', //the title of column
                dataIndex: 'alternativeName', //the data index can be used for searching, filtering
                key: 'alternativeName',
                width: '50%',
            },
            {
                title: 'Alternative Description',
                dataIndex: 'alternativeDescription',
                key: 'alternativeDescription',
                width: '50%',
            }];
            content2 = ( //evaluator list default
                <Col span={16} style={this.state.count === 2 ? { visibility: "visible" } : { visibility: "hidden", display: "none" }}>
                    <Row style={{ marginTop: "2vh" }} type="flex" justify="space-around" align="middle">
                        <Col >
                            <div className="lander">
                                <div style={{ height: "100%" }} >
                                    <h1 style={{ display: "inline" }}>Here are the alternatives for this project.</h1>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row style={{ marginTop: "5vh" }} type="flex" justify="space-around" align="middle">
                        <Col span={16} >
                            <ConfigProvider renderEmpty={() => { return (<Empty />); }}>
                                <Table columns={Acolumns}
                                    size="small"
                                    rowKey={record => record._id} //unique key needed, so we use mongodb id
                                    dataSource={alternativeList} //the data source is what we get after component mount
                                />
                            </ConfigProvider>
                        </Col>
                    </Row>
                    <Row style={{ marginTop: "2vh" }} type="flex" justify="space-around" align="middle">
                        <Col >
                            <div className="lander">
                                <div style={{ height: "100%" }} >
                                    <h1 style={{ display: "inline" }}>Here is the list of criteria in your group.</h1>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row style={{ marginTop: "5vh" }} type="flex" justify="space-around" align="middle">
                        <Col span={16} >
                            <ConfigProvider renderEmpty={() => { return (<Empty />); }}>
                                <Table columns={columns}
                                    size="small"
                                    rowKey={record => record._id} //unique key needed, so we use mongodb id
                                    dataSource={criteriaList} //the data source is what we get after component mount
                                />
                            </ConfigProvider>
                        </Col>
                    </Row>
                </Col>
            );
        }
        let content3
        if (this.state.projectActorGroup.actorCriteria) {
            content3 = ( //evaluator list default
                <Col span={16} style={this.state.count === 3 ? { visibility: "visible" } : { visibility: "hidden", display: "none" }}>
                    <Row style={{ marginTop: "2vh" }} type="flex" justify="space-around" align="middle">
                        <Col span={16}>
                            <CriteriaForm
                                wrappedComponentRef={this.saveCFormRef}
                                projectActorGroup={this.state.projectActorGroup}
                            />
                        </Col>
                    </Row>
                </Col>
            );
        }
        // let content4
        // if (this.state.projectActorGroup.actorCriteria) {
        //     content4 = ( //evaluator list default
        //         <Col span={16} style={this.state.count === 4 ? { visibility: "visible" } : { visibility: "hidden", display: "none" }}>
        //             <Row style={{ marginTop: "2vh" }} type="flex" justify="space-around" align="middle">
        //                 <Col span={16}>
        //                     <EvaluationForm
        //                         wrappedComponentRef={this.saveEFormRef}
        //                         projectActorGroup={this.state.projectActorGroup}
        //                         project={this.state.project}
        //                     />
        //                 </Col>
        //             </Row>
        //         </Col>
        //     );
        // }
        return (
            <div className="MAMCASurvey">
                <Row type="flex" justify="space-around" align="middle">
                    {content0}
                    {content2}
                    {content3}
                    {/* {content4} */}

                </Row>
                <Row style={{ marginTop: "5vh", paddingBottom: "5vh" }} type="flex" justify="space-around" align="middle">
                    <Col span={6}>{this.state.count === 0 ? <span></span> : <Button style={{ margin: "0 auto", display: "block" }} type="primary" size="large" onClick={this.onclick.bind(this, 'sub')}><Icon type="caret-left" /></Button>}</Col>
                    <Col span={6}>{this.state.count === this.state.maximumCount ?
                        <Popconfirm title="Are you sure you want to submit? Once you submit you cannot do any change!" onConfirm={this.submit} okText="Yes" cancelText="No">
                            <Button style={{ margin: "0 auto", display: "block" }} type="primary" size="large"><Icon type="upload" /></Button>
                        </Popconfirm>
                        : <Button style={{ margin: "0 auto", display: "block" }} type="primary" size="large" onClick={this.onclick.bind(this, 'add')}><Icon type="caret-right" /></Button>}</Col>
                </Row>
            </div >
        );
    }
}